import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { FinancingCompaniesActions } from "./financing-companies.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// FINANCING COMPANIES REDUCER (array format for PagesStore)
// **************************************************************************

const invalidate = on(FinancingCompaniesActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, loaded: false },
})));

const load = on(FinancingCompaniesActions.load, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, loading: true, error: null },
})));

const loadSuccess = on(FinancingCompaniesActions.loadSuccess, (state: PagesStore, { financingCompanies }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, financingCompanies, loaded: true, loading: false, error: null },
})));

const loadFailure = on(FinancingCompaniesActions.loadFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, loading: false, error },
})));

const createFinancingCompany = on(FinancingCompaniesActions.createFinancingCompany, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const createFinancingCompanySuccess = on(FinancingCompaniesActions.createFinancingCompanySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const createFinancingCompanyFailure = on(FinancingCompaniesActions.createFinancingCompanyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error },
})));

const updateFinancingCompany = on(FinancingCompaniesActions.updateFinancingCompany, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const updateFinancingCompanySuccess = on(FinancingCompaniesActions.updateFinancingCompanySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const updateFinancingCompanyFailure = on(FinancingCompaniesActions.updateFinancingCompanyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error },
})));

const deleteFinancingCompany = on(FinancingCompaniesActions.deleteFinancingCompany, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const deleteFinancingCompanySuccess = on(FinancingCompaniesActions.deleteFinancingCompanySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error: null },
})));

const deleteFinancingCompanyFailure = on(FinancingCompaniesActions.deleteFinancingCompanyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    financingCompanies: { ...superUserState.financingCompanies, error },
})));

export const financingCompaniesReducer = [
    invalidate,
    load,
    loadSuccess,
    loadFailure,
    createFinancingCompany,
    createFinancingCompanySuccess,
    createFinancingCompanyFailure,
    updateFinancingCompany,
    updateFinancingCompanySuccess,
    updateFinancingCompanyFailure,
    deleteFinancingCompany,
    deleteFinancingCompanySuccess,
    deleteFinancingCompanyFailure,
];
